import React from 'react'
import './collections_sub.css'
import Footer from '../../Home/Home_modules/Footerr/footer'
import topbanner from './Im/sivajiban.png'
import topimg from './Im/sivajithumb.jpg'
import sharebtn from './Im/sharebtn2.png'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Cards_Sivaji from '../../Home/Home_modules/cards_sivaji';


function Sivaji() {
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
          partialVisibilityGutter: 30
        }
      };
    return (
        <div>
            <div className="collections-sub-top">
                <img src={topbanner} />
            </div>
            <div className="collections-sub-top2">
                <img src={topimg} />
                <h1>Sivaji</h1>
                <p>Sivaji: The Boss is a 2007 Indian cult-classic Tamil-language action film produced by AVM Productions. The film stars Rajinikanth and A R Rahman composed the soundtrack and background music. The movie raked over 150 crores in the box office in 2007!</p>
                <div className="collections-sub-topbtns">
                <button className="collections-sub-sharebtn"><i className="fas fa-share"></i></button><button className="collections-sub-sharebtn"><i className="fas fa-ellipsis-h"></i></button>
                </div>
            </div>
            <div className="explore">
              
           <div className="collection-explore-d">
           <Cards_Sivaji />
</div>





</div>
        <Footer/>
        </div>
    )
}

export default Sivaji
